import React, { useRef, useEffect } from "react";
import { FaCalendarAlt, FaHandPeace, FaRocket } from "react-icons/fa";
import "./ServerFree.css";

const ServerFree = () => {
  const cardRef = useRef(null);
  const calendarRef = useRef(null);
  const textRef = useRef(null);
  const goodbyeRef = useRef(null);

  useEffect(() => {
    // Card entrance animation
    if (cardRef.current) {
      cardRef.current.style.animation = "scaleIn 0.6s ease-out forwards";
    }

    // Calendar bounce animation
    if (calendarRef.current) {
      calendarRef.current.style.animation = "bounce 2s ease-in-out infinite";
    }

    // Text fade-in animation
    if (textRef.current) {
      textRef.current.style.animation = "fadeIn 1.5s ease-out 0.3s forwards";
    }

    // Goodbye icon rotation
    if (goodbyeRef.current) {
      goodbyeRef.current.style.animation = "rotate 3s linear infinite";
    }
  }, []);

  return (
    <div className="server-free-container">
      <div className="server-free-card" ref={cardRef}>
        {/* Left — Animated Calendar Box */}
        <div className="calendar-box" ref={calendarRef}>
          <FaCalendarAlt className="calendar-icon" />
          <div className="calendar-number">25</div>
          <FaRocket className="rocket-icon" />
        </div>

        {/* Center — Text Content */}
        <div className="text-container" ref={textRef}>
          <div className="heading-row">
            <div className="small-heading">25 YEARS</div>
            <div className="badge">🎉 EXCLUSIVE</div>
          </div>
          <div className="big-heading">FREE SERVER HOSTING</div>
          <div className="description">
            💥 Server fees draining you? Not with us. Anything we build is hosted free for 25 years.
            Build with Instant Digits and you'll never pay a hosting bill again — a promise no
            competitor can touch.
          </div>
          <div className="highlight-box">
            <div className="highlight-text">💰 Save Thousands $ Every Year!</div>
          </div>
        </div>

        {/* Right — Animated Goodbye Icon */}
        <div className="goodbye-container" ref={goodbyeRef}>
          <FaHandPeace className="goodbye-icon" />
        </div>
      </div>

      <style>{`
        @keyframes scaleIn {
          from {
            transform: scale(0);
          }
          to {
            transform: scale(1);
          }
        }

        @keyframes bounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-15px);
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes rotate {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default ServerFree;
